@if (!isLoading) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>Authentication</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-auth-save-btn" type="submit" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid || isSaving || (authenticationMethodCtrl.value == 'otds' && !this.canEdit)">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-auth-reset-btn" type="reset" class="ot-btn ot-btn--is-secondary" (click)="reset()"
          [disabled]="isSaving || (authenticationMethodCtrl.value == 'otds' && !this.canEdit)" i18n>
          Reset
        </button>
      </div>
    </div>
  </div>
  <div [style]="'height: calc(100vh - 160px);'">
    <ng-scrollbar #scrollbarRef>
      @if (isOTDSAdminGroupSelectionNeeded) {
      <div class="ot-message ot-message--is-warning">
        <div class="ot-message__banner">
          <p class="ot-pl-1" id="otsc-settings-auth-otds-incomplete-msg">
            Please select Administrators group to save your changes once a resource is activated.
          </p>
        </div>
      </div>
      }
      <form [formGroup]="settingsForm" name="otsc-settings-authentication-form">
        <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2">
          <div id="otsc-settings-authentication">
            <div class="otsc-settings-label otsc-settings-label-desc" i18n>
              Use this page to configure the authentication method.
            </div>
            <fieldset [disabled]="!this.canEdit">
              <div id="otsc-settings-auth-method-radio-buttons" class="ot-form-control">
                <label class="ot-form-control__label" i18n>
                  Select authentication method:
                </label>
                <div class="ot-radio-group">
                  <div class="ot-radio-options">
                    <label class="ot-radio">
                      <input id="otsc-settings-auth-method-local-radio-button" type="radio"
                        formControlName="authenticationMethodCtrl" value="local">
                      <span class="ot-radio__wrapper">
                        <span class="ot-radio__icon">
                        </span>
                        <span class="ot-radio__text">
                          Local authentication
                        </span>
                      </span>
                    </label>
                    <label class="ot-radio">
                      <input id="otsc-settings-auth-method-otds-radio-button" type="radio"
                        formControlName="authenticationMethodCtrl" value="otds">
                      <span class="ot-radio__wrapper">
                        <span class="ot-radio__icon">
                        </span>
                        <span class="ot-radio__text">
                          OpenText Directory Services
                        </span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              @if (authenticationMethodCtrl.value == 'otds') {
              <div id="otsc-settings-auth-otds">
                <div class="otsc-settings-label otsc-settings-label-desc" i18n>
                  Provide Directory Services server details for authentication.
                </div>
                <div class="row">
                  <div class="ot-btn-group ot-pl-0">
                    <button id="otsc-settings-auth-otds-activate-btn" type="button" class="ot-btn ot-btn--is-secondary"
                      (click)="activateOTDSResource()"
                      [disabled]="isSaving || (otdsURLCtrl.invalid || otdsResourceIdCtrl.invalid)" i18n>
                      Activate resource
                    </button>
                    <button id="otsc-settings-auth-otds-test-conn-btn" type="button" class="ot-btn ot-btn--is-secondary"
                      (click)="testOTDSURL()" [disabled]="isSaving || (otdsURLCtrl.invalid)" i18n>
                      Test connection
                    </button>
                  </div>
                </div>
                <div class="ot-row">
                  <div class="ot-col ot-row__column ot-row__column--is-33">
                    <div class="ot-form-control"
                      [ngClass]="{'ot-form-control--is-invalid' : otdsURLCtrl.dirty && otdsURLCtrl.invalid}">
                      <label class="ot-form-control__label ot-form-control__required-indicator"
                        for="otsc-settings-auth-otdsURL" i18n>
                        Server URL
                      </label>
                      <div class="ot-form-control__input-group">
                        <input id="otsc-settings-auth-otdsURL" formControlName="otdsURLCtrl"
                          placeholder="Enter Directory Services server URL" type="text" maxlength="200"
                          class="ot-input ot-input--is-expanded">
                        @if (otdsURLCtrl.invalid) {
                        <span class="ot-form-control__error-icon"></span>
                        }
                      </div>
                      @if (otdsURLCtrl.dirty && otdsURLCtrl.invalid && otdsURLCtrl.errors.required) {
                      <p id="otsc-settings-auth-otdsURLRequiredMsg" class="ot-form-control__error-text" i18n
                        autocomplete="off">
                        Server URL is required.
                      </p>
                      }
                      @if (otdsURLCtrl.dirty && otdsURLCtrl.invalid && otdsURLCtrl.errors.pattern) {
                      <p id="otsc-settings-auth-invalidOTDSURLMsg" class="ot-form-control__error-text" i18n
                        autocomplete="off">
                        Server URL must start with http:// or https://.
                      </p>
                      }
                    </div>
                  </div>
                </div>
                <div class="ot-row">
                  <div class="ot-col ot-row__column ot-row__column--is-33">
                    <div class="ot-form-control"
                      [ngClass]="{'ot-form-control--is-invalid' : otdsResourceIdCtrl.dirty && otdsResourceIdCtrl.invalid}">
                      <label class="ot-form-control__label ot-form-control__required-indicator"
                        for="otsc-settings-auth-otdsResourceId" i18n>
                        Resource Identifier
                      </label>
                      <div class="ot-form-control__input-group">
                        <input id="otsc-settings-auth-otdsResourceId" formControlName="otdsResourceIdCtrl"
                          placeholder="Enter Directory Services resource identifier" type="text" maxlength="200"
                          class="ot-input ot-input--is-expanded">
                        @if (otdsResourceIdCtrl.invalid) {
                        <span class="ot-form-control__error-icon"></span>
                        }
                      </div>
                      @if (otdsResourceIdCtrl.dirty && otdsResourceIdCtrl.invalid && otdsResourceIdCtrl.errors.required)
                      {
                      <p id="otsc-settings-auth-otdsResourceIdRequiredMsg" class="ot-form-control__error-text" i18n
                        autocomplete="off">
                        Resource Identifier is required.
                      </p>
                      }
                    </div>
                  </div>
                </div>
                <div class="ot-row">
                  <div class="ot-col ot-row__column ot-row__column--is-33">
                    <div class="ot-form-control"
                      [ngClass]="{'ot-form-control--is-invalid' : otdsURLCtrl.valid && otdsResourceIdCtrl.valid && otdsUserGroupCtrl.touched && otdsUserGroupCtrl.invalid}">
                      <label class="ot-form-control__label ot-form-control__required-indicator"
                        for="otsc-settings-auth-otdsUserGroup" i18n>
                        Administrators group
                      </label>
                      <div class="ot-select ot-pb-0"
                        [ngClass]="{'ot-select--has-error': otdsURLCtrl.valid && otdsResourceIdCtrl.valid && otdsUserGroupCtrl.touched && otdsUserGroupCtrl.invalid}">
                        <select id="otsc-settings-auth-otdsUserGroup" name="otdsUserGroup"
                          formControlName="otdsUserGroupCtrl" aria-label="Select a group">
                          <option value="" i18n>Select administrators group</option>
                          @for (group of OTDSUserGroups; track group) {
                          <option [value]="group">{{group}}</option>
                          }
                        </select>
                      </div>
                      @if (otdsURLCtrl.valid && otdsResourceIdCtrl.valid && otdsUserGroupCtrl.touched &&
                      otdsUserGroupCtrl.invalid) {
                      <p id="otsc-settings-auth-otdsUserGroupRequiredMsg" class="ot-form-control__error-text" i18n
                        autocomplete="off">
                        Administrators group is required.
                      </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
              }
            </fieldset>
            @if (authenticationMethodCtrl.value == 'local') {
            <div id="otsc-settings-auth-local">
              <div class="otsc-settings-label otsc-settings-label-desc" i18n>
                Local Account Policy
              </div>
              <div class="ot-row">
                <div class="ot-col ot-row__column ot-row__column--is-33">
                  <div class="ot-form-control"
                    [ngClass]="{'ot-form-control--is-invalid' : authenticationMethodCtrl.value == 'local' && accountLockDurationCtrl.invalid}">
                    <label class="ot-form-control__label" for="otsc-settings-auth-accountLockDuration" i18n>
                      Account Lockout Duration
                    </label>
                    <div class="ot-form-control__input-group">
                      <input id="otsc-settings-auth-accountLockDuration" formControlName="accountLockDurationCtrl"
                        type="number" class="ot-input ot-input--is-expanded">
                      @if (accountLockDurationCtrl.invalid) {
                      <span class="ot-form-control__error-icon"></span>
                      }
                    </div>
                    @if (accountLockDurationCtrl.invalid) {
                    <p id="otsc-settings-auth-accountLockDurationRequiredMsg" class="ot-form-control__error-text" i18n
                      autocomplete="off">
                      Invalid account lockout duration specified, the value can be set between 1 and 60.
                    </p>
                    }
                    <p id="otsc-settings-auth-accountLockDurationInfoText" class="ot-form-control__info-text" i18n>
                      The account lockout duration setting determines the number of minutes that a locked-out account
                      remains locked out before automatically becoming unlocked. The available range is from 1 through
                      60 minutes.
                    </p>
                  </div>
                </div>
              </div>
              <div class="ot-row">
                <div class="ot-col ot-row__column ot-row__column--is-33">
                  <div class="ot-form-control"
                    [ngClass]="{'ot-form-control--is-invalid' : authenticationMethodCtrl.value == 'local' && accountLockoutThresholdCtrl.invalid}">
                    <label class="ot-form-control__label" for="otsc-settings-auth-accountLockoutThreshold" i18n>
                      Account Lockout Threshold
                    </label>
                    <div class="ot-form-control__input-group">
                      <input id="otsc-settings-auth-accountLockoutThreshold"
                        formControlName="accountLockoutThresholdCtrl" type="number"
                        class="ot-input ot-input--is-expanded">
                      @if (accountLockoutThresholdCtrl.invalid) {
                      <span class="ot-form-control__error-icon"></span>
                      }
                    </div>
                    @if (accountLockoutThresholdCtrl.invalid) {
                    <p id="otsc-settings-auth-accountLockoutThresholdRequiredMsg" class="ot-form-control__error-text"
                      i18n autocomplete="off">
                      Invalid account lockout threshold specified, the value can be set between 1 and 10.
                    </p>
                    }
                    <p id="otsc-settings-auth-accountLockoutThresholdInfoText" class="ot-form-control__info-text" i18n>
                      The account lockout threshold setting determines the number of failed sign-in attempts that will
                      cause a user account to be locked. The available range is from 1 through 10.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </form>
    </ng-scrollbar>
  </div>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n id="otsc-settings-auth-loading">Loading...</div>
</div>
}